module.exports = __webpack_public_path__ + "static/fire-extinguisher-c309efe2856f4664f6b44a6a8c4ede74.svg";